var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AppConfig } from '../../app.config';
import { ApiResponse } from './../_base/apiResponse.model';
var LoginResponseModel = /** @class */ (function (_super) {
    __extends(LoginResponseModel, _super);
    function LoginResponseModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.token = null;
        _this.incomplete = false;
        _this.displayLanguage = AppConfig.defaultLocale;
        _this.hasSeenLatestPolicy = false;
        return _this;
    }
    return LoginResponseModel;
}(ApiResponse));
export { LoginResponseModel };



// WEBPACK FOOTER //
// ./src/app/models/auth/loginResponse.model.ts.pre-build-optimizer.js